<template>
    <div id="content" class="w">
        <div class="cal" id="ca0">
            <div class="hot_pcg">
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Anal-Toys-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">后庭玩具</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Cock-Rings-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">锁精环</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Dildos-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">G点棒</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Love-Eggs-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">震动跳蛋</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Nav-Tile-template-Butt-Plugs.jpg" class="hot_cmg"><p class="hot_cmp">肛塞</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Nav-Tile-template-Penis-Enlargers.jpg" class="hot_cmg"><p class="hot_cmp">阴茎锻炼</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Nav-Tile-template-Rabbit-Vibrators-2.jpg" class="hot_cmg"><p class="hot_cmp">震动棒</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Sex-Toys-for-Couples-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">情侣玩具</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Sex-Toys-for-Men-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">飞机杯</p></a>
                <a href="javascript:;" class="hot_cms"><img src="../../assets/image/fenlei/Vibrators-nav-tile-900x1200.jpg" class="hot_cmg"><p class="hot_cmp">AV棒</p></a>
            </div>
            <div class="clear"></div>
        </div>
        <div class="cbox" id="cbox">
            <div class="cal" id="ca" v-for="(item,index) in cate" :key="index">
                <h2 class="h_bh1">{{item.title}}</h2>
                <div class="cat_bodf cat_pld">
                    <h2 class="h_bh">{{item.title}}</h2>
                    <a href="javascript:;" class="cla" v-for="(items,indexs) in item.z" :key="indexs" @click="$router.push({path:'/shop/shopsearch',query:{cate_id:items.id}})"><img :src="items.piclink" width="70" height="70" class="c_img"><p>{{items.title}}</p></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //数据
            cate:[],
            type: 1,
            allCategory:
            [
                {
                    name:"男性用品",
                    children:[
                        {name:"飞机杯",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"自感软胶",url:"javascript:;",src:require("../../assets/picture/49.jpg")},
                        {name:"臀胸倒模",url:"javascript:;",src:require("../../assets/picture/48.jpg")},
                        {name:"实体娃娃",url:"javascript:;",src:require("../../assets/picture/4.jpg")},
                    ]
                },
                {
                    name:"女性用品",
                    children:[
                        {name:"情趣跳蛋",url:"javascript:;",src:require("../../assets/picture/64.jpg")},
                        {name:"仿真阳具",url:"javascript:;",src:require("../../assets/picture/7.jpg")},
                        {name:"震动棒",url:"javascript:;",src:require("../../assets/picture/197.jpg")},
                        {name:"胸部挑逗",url:"javascript:;",src:require("../../assets/picture/62.jpg")},
                        {name:"隐形穿戴",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                        {name:"紧致缩阴",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                        {name:"阴蒂刺激",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                    ]
                },
                {
                    name:"套套世界",
                    children:[
                        {name:"杜蕾斯",url:"javascript:;",src:require("../../assets/picture/26.jpg")},
                        {name:"第六感",url:"javascript:;",src:require("../../assets/picture/98.jpg")},
                        {name:"杰士邦",url:"javascript:;",src:require("../../assets/picture/56.jpg")},
                    ]
                },
                {
                    name:"助兴用品",
                    children:[
                        {name:"外用延时",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"女用快感",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"润滑滋养",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"情趣套套",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
                {
                    name:"另类玩具",
                    children:[
                        {name:"G点后庭",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"SM套装",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"情趣服饰",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
                {
                    name:"特惠专区",
                    children:[
                        {name:"每日特惠",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
            ],
        }
    },
    mounted() {
        this.getShopCate();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
    }
}
</script>

<style scoped>
.cbox{margin:0 0 30px 0;overflow:hidden;zoom:1;}
.h_bh1{font-size:26px;font-weight:bold;color:#000;padding:5px 0;line-height:40px;position:relative;width:100%;}
.h_bt2{margin:10px 0 0;color:#999;}
.h_rm{height:30px;position:absolute;top:6px;right:0;background:url(../../assets/image/v.png) right -382px no-repeat;color:#999;padding-right:20px;line-height:30px;font-size:12px;font-weight:normal;}
.cat_tag{display:flex;justify-content:space-between;flex-wrap:wrap;align-content:flex-start;padding:10px 0;}
.cl_tg{background-color:#f2f2f2;color:#000;display:inline-block;padding:0 10px;margin:0 5px 5px 0;line-height:40px;border-radius:4px;font-weight:bold;white-space:nowrap;overflow:hidden;text-overflow: ellipsis;flex-grow:3;text-align:center;}
.cl_ico{vertical-align:middle;margin:-3px 5px 0 0;}
.cla{width:16%;padding:10px 0;height:70px;display:inline-block;text-align:center;overflow:hidden;color:#333;font-size:14px;line-height:20px;float:left;}
.nbtn{width:90%;line-height:3rem;border-radius:40px; text-align:center; background-color:#f5f5f5;display:block;color:#999;font-size:13px;margin:2rem auto;}
.c_img{width:50px;height:50px;}
.cat_bodf{overflow:hidden;zoom:1;padding:0 0 15px 0;position:relative;}
.h_bh{font-size:14px;color:#fff;font-weight:400;line-height:16px;width:16px;position:absolute;left:5px;top:15px;background-color:#000;padding:3px;}
.cal{margin-bottom:10px;border-bottom:1px solid #f1f1f1;padding:20px 40px;background-color:#fff;}
.c_l{height:46px;margin:30px 0 0 0;border-bottom:1px solid #eee;}
.c_lul{background-color:#fff;height:45px;}
.c_lul li{float:left;margin:2px 0 0 15px;font-size:14px;color:#333;border-bottom:2px solid #fff;height:34px;line-height:34px;cursor:pointer;}
.c_lul li.on{color:#d01e1e;border-color:#d01e1e;font-weight:bold;font-size:16px;}
.ca_th{width:90px;margin:10px 0 10px 15px;float:left;background-color:#eee;text-align: center;color:#333;line-height:30px;border-radius:6px;}
.fx_tops{position:fixed;top:0;z-index:10;width:1190px;box-shadow:0px 2px 5px rgba(0,0,0,0.1);}
.cat_pld{padding-left:60px;}
#ca0{padding:0;}
.hot_pcg{overflow:hidden;zoom:1;margin-top:20px;}
.hot_cms{width:20%;float:left;position:relative;overflow:hidden;background-color:#000;display:inline-block;height:260px;}
.hot_cmg{width:100%;opacity:0.9;transition:all 0.3s;}
.hot_cmp{position:absolute;left:0;right:0;top:45%;color:#fff;text-align:center;font-size:26px;font-weight:700;height:40px;line-height:40px;_width:100%;}
.hot_cms:hover .hot_cmg{opacity:1;transform:scale(1.03);}
</style>


// WEBPACK FOOTER //
// src/components/category/Index.vue